import en from "./Translations/en";
import fr from "./Translations/fr";
import nl from "./Translations/nl";

const Translations = {
  en,
  nl,
  fr,
};

const _ = (lang) => Translations[lang];

export default _;
